export default __webpack_public_path__ + "static/media/cartbtn.ba650e8f.svg";